<template>
    <v-dialog v-model="dialog" max-width="800px">
      <v-card>
        <v-card-title>Ordner auswählen</v-card-title>
        <v-container>
          <v-row class="mx-2">
            <v-col class="align-center justify-space-between" cols="12">
              <v-row align="center" class="mr-0">
                <v-select
                  v-model="selectedFolder"
                  :items="folders"
                  item-text="folderName"
                  item-value="id"
                ></v-select>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
        <v-card-actions>
          <v-btn id="leftButton" text @click.stop="close()">Abbrechen</v-btn>
          <v-btn id="rightButton" @click.stop="submitFolder()" color="primary">Speichern</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
  
  export default {
    data() {
      return {
        selectedFolder: null,
        dialog: false,
        resolve: null,
        reject: null,
        folders: []
      };
    },
    methods: { 
        open(folders) {
            this.folders = folders;
            this.dialog = true;
            return new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });
        },
        close(){
            this.reject();
            this.dialog = false;
        },
        submitFolder(){
            this.resolve(this.selectedFolder);
            this.dialog = false;
        }
    }
  };
  </script>
  